<template class="">
    <div class="orderView">
    <h3 class="has-text-centered orderView-title">ORDER CONFIRMATION FORM</h3>
    <div class=" pd-20 compare-section container">
    <div class="columns">
        <div class="column">
        </div>
        <div class="column is-half form-card">
            <!-- <form id="ggform" class="gform" method="post"
            data-email="madamranee.official@gmail.com"
            action ="
            https://script.google.com/macros/s/AKfycbwrFV1EZISyF1ZGNNZTWdY5SjznvY6Y1O0x9Eme/exec"
            > -->
            <form id="ggform" class="gform" data-email="madamranee.official@gmail.com"
            v-on:submit.prevent="submitForm">
              <b-loading :is-full-page="true"
              :can-cancel="true" :active="isLoading"></b-loading>
              <b-field label="Item List (Can not edit)">
                <b-input
                  :value="itemListText"
                  type="textarea"
                  name="itemList"
                  :rows="products.length"
                  readonly
                  :disabled="checkOrder == false"
                >
                </b-input>
              </b-field>
              <b-field label="Name*">
                  <b-input value="" name="name"
                  :disabled="checkOrder == false"
                  v-model="name"
                  required>
                  </b-input>
              </b-field>
              <b-field label="Address*">
                  <b-input maxlength="200" type="textarea" value="" name="address"
                  v-model="address"
                  :disabled="checkOrder == false"
                  required></b-input>
              </b-field>
              <b-field label="Email*">
                  <b-input value="" name="email"
                  v-model="email"
                  :disabled="checkOrder == false"
                  required></b-input>
              </b-field>
              <b-field label="ID Line">
                  <b-input value="" name="idLine"
                  v-model="idline"
                  :disabled="checkOrder == false"
                  ></b-input>
              </b-field>
              <b-field label="Whatsapp">
                  <b-input value="" name="whatsapp"
                  v-model="whatsapp"
                  :disabled="checkOrder == false"
                  ></b-input>
              </b-field>
               <!-- <b-field label="Product Type">
                  <b-select placeholder="Select a Product type" name="producttype">
                      <option value="WhiteningAndDeodorant">Whitening & Deodorant</option>
                      <option value="ExtraWhitening">Extra-Whitening</option>
                      <option value="NanoExtraWhiteningGlutathione">
                        Nano Extra-Whitening + Glutathione</option>
                      <option value="OrganicFormula">Organic Formula</option>
                      <option value="ExportOnly">Export only</option>
                  </b-select>
              </b-field>
              <b-field label="Amount of Order (whole sale minimum order 1 carton 100 pcs.)">
                  <b-input  type="number" value="" name="amount"></b-input>
              </b-field> -->
               <b-field label="Port Destination*">
                  <b-input value=""
                  name="portdestination"
                  v-model="portdestination"
                  :disabled="checkOrder == false"
                  required></b-input>
              </b-field>
              <b-field label="Country*">
                  <b-input value="" name="country"
                  :disabled="checkOrder == false"
                  v-model="country"
                  required></b-input>
              </b-field>
              <b-field label="City*">
                  <b-input value="" name="city"
                  v-model="city"
                  :disabled="checkOrder == false"
                  required></b-input>
              </b-field>
              <b-field label="Payment by*" class="form-card-box">
                  <b-radio
                    name="payment"
                    v-model="payment"
                    size="is-small"
                    native-value="bank account tranfer"
                    class="md-radio"
                    :disabled="checkOrder == false"
                    value="TT Money to bank account number"
                    required>
                      TT Money to bank account number
                  </b-radio>
                  <b-radio
                    name="payment"
                    v-model="payment"
                    size="is-small"
                    native-value="Western union"
                    class="md-radio"
                    :disabled="checkOrder == false"
                    value="Western union"
                    required>
                      Western union
                  </b-radio>
              </b-field>
              <div class="form-card-submit has-text-centered">
                  <b-button tag="input"
                  native-type="submit"
                  class="has-text-black form-card-button-confirm"
                  label="CONFIRM ORDER"
                  v-if="checkOrder"
                  value="CONFIRM ORDER"
                  >
                   <!-- <b-button tag="input"
                  class="has-text-black form-card-button-confirm"
                  label="CONFIRM ORDER"
                  v-if="checkOrder"
                  > -->
                      CONFIRM ORDER
                  </b-button>
                  <b-button
                  @click="cancel()"
                  class="has-text-black form-card-button-cancel"
                  v-if="checkOrder"
                >
                      CANCEL
                </b-button>
              </div>
            </form>
        </div>
        <div class="column"></div>
    </div>
    </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';
import swal from 'sweetalert';

export default {
  name: 'OrderConfirmView',
  components: {
    // Productconfirm,
  },
  computed:
  {
    itemListText() {
      let temp = '';
      this.products.forEach(element => {
        temp = temp.concat(
          element.product_name, ' : ', element.amount, '\n',
        );
      });
      return temp;
    },
    ...mapState({
      Productconfirm: state => state.productconfirm,
      ProductCart: state => state.productCart,
    })
  },
  data() {
    return {
      products: [],
      payment: 'default',
      itemList: '',
      name: '',
      address: '',
      email: '',
      idline: '',
      whatsapp: '',
      portdestination: '',
      country: '',
      city: '',
      checkOrder: true,
      isLoading: false,
    };
  },
  created() {
    this.products = this.ProductCart;
    console.log(this.products);
  },
  methods: {
    async submitForm() {
      // const abc = [
      //   { message: 'Foo' },
      //   { message: 'Bar' }
      // ];
      // axios({
      //   method: 'POST',
      //   url: 'https://script.google.com/macros/s/AKfycbxJkd0A_ZETLftF0etKG1MMC7y3aD7tfTfpcqGjx9v9rm1o0mM/exec',
      //   data: {
      //     name: 'amarin',
      //     email: 'laoamarin@gmail.com',
      //   },
      //   headers: {
      //     'Content-type': 'application/json',
      //   }
      // });
      // const request = new Request(
      //   'https://script.google.com/macros/s/AKfycbxJkd0A_ZETLftF0etKG1MMC7y3aD7tfTfpcqGjx9v9rm1o0mM/exec',
      //   {
      //     method: 'POST',
      //     mode: 'cors',
      //     cache: 'default',
      //     body: JSON.stringify(abc)
      //   }
      // );
      // const res = await fetch(request);
      // console.log(request);
      // console.log(res);
      // const data = await res.json();
      // this.data = data;
      // console.log(this.data);

      // const { data } = await axios.post(
      //   'https://script.google.com/macros/s/AKfycbxJkd0A_ZETLftF0etKG1MMC7y3aD7tfTfpcqGjx9v9rm1o0mM/exec',
      //   this.post
      // );
      // this.data = data;
      const bodyFormData = new FormData();
      this.isLoading = true;
      bodyFormData.append('city', this.city);
      bodyFormData.append('itemList', document.getElementsByName('itemList')[0].value);
      bodyFormData.append('name', this.name);
      bodyFormData.append('address', this.address);
      bodyFormData.append('idline', this.idline);
      bodyFormData.append('email', this.email);
      bodyFormData.append('whatsapp', this.whatsapp);
      bodyFormData.append('portdestination', this.portdestination);
      bodyFormData.append('country', this.country);
      bodyFormData.append('payment', this.payment);
      await axios({
        method: 'post',
        mode: 'cors',
        url: 'https://script.google.com/macros/s/AKfycbwrFV1EZISyF1ZGNNZTWdY5SjznvY6Y1O0x9Eme/exec',
        data: bodyFormData,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally((dat) => {
          console.log(dat);
          this.isLoading = false;
          swal({
            title: 'Order Successful',
            text: 'We will contact you later!',
            icon: 'success',
            button: 'DONE',
          });
          this.checkOrder = false;
          const tempProducts = [];
          this.$store.commit('updateproductCart',
            tempProducts
          );
        });
      // axios.post('https://script.google.com/macros/s/AKfycbxJkd0A_ZETLftF0etKG1MMC7y3aD7tfTfpcqGjx9v9rm1o0mM/exec', abc, {
      //   headers: {
      //     // remove headers
      //   }
      // })
      //   .then((response) => {
      //     console.log(response);
      //   }, (error) => {
      //     console.log(error);
      //   });
      // axios.post('https://script.google.com/macros/s/AKfycbxJkd0A_ZETLftF0etKG1MMC7y3aD7tfTfpcqGjx9v9rm1o0mM/exec', this.form)
      //   .then((res) => {
      //     console.log(res);
      //   }).catch((error) => {
      //     console.log(this.form);
      //     swal({
      //       title: 'Error',
      //       icon: 'error',
      //       button: 'Cancel',
      //     });
      //     console.log(error);
      //   }).finally(() => {
      //     console.log('finaly');
      //   });
    },
    sendOrder() {
      console.log('sendOrderrr');
    },
    cancel() {
      this.$router.push({
        name: 'Order',
        params: {
        },
      });
    },
    openLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 5 * 1000);
      console.log('loading');
    },
    confirmOrder() {
    }
  }
};
</script>
<style lang="scss" scoped>
.orderView{
    padding-top:30px;
    background: #f2f2f2;
    &-title{
     font-size:xx-large;
     font-weight: bold;
    }
    &-submit{
        display: inline-flex;
        padding-top:30px;
        padding-bottom:30px;
    }
}
.md-radio{
  margin-bottom:20px;
}
.form-card{
    border-radius: 10px;
    background: white;
    box-shadow: grey;
    padding: 50px ;
    margin-bottom: 50px;

    &-box{
        display: grid;
        line-height: 20px;
    }
    &-button-confirm{
      margin-top:2rem;
      background: url("../../assets/img/home/button-menu-active.png");
      background-position: center;
      font-size: 20px;
      margin-right:20px;
      width:13rem;
    }
    &-button-cancel{
      margin-top:2rem;
      background-position: center;
      font-size: 20px;
      width:13rem;
    }
}
.compare-section{
    &-title{
        font-size:20px;
    }
}
.pd-20{
    padding: 30px;
}
.text-title{
    font-size: 30px;
}
</style>
